module.exports = __webpack_public_path__ + "static/media/tm4.aac5b579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd503/tm4.jpg
// module id = 181
// module chunks = 0